import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { rem } from '../utilities/style';
import { colors } from '../theme/colors';
import { fontWeights } from '../theme/type';

const Container = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

const ToggleButton = styled.button`
  position: relative;
  border: 1px solid ${colors.gray['200']};
  background: ${colors.white};
  border-radius: ${rem(50)};
  font-weight: ${fontWeights.semiBold};
  color: ${colors.blue['800']};
  padding: ${rem(12)} ${rem(18)};
  cursor: pointer;
  width: ${rem(64)};
  height: ${rem(40)};

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: ${rem(3)};
    width: ${rem(32)};
    height: ${rem(32)};
    border-radius: 50%;
    background: ${colors.gray['300']};
    transition: transform 0.2s ease-in-out;
  }

  &[aria-pressed=true]::before {
    transform: translateY(-50%) translateX(${rem(24)});
    background: ${colors.blue['500']};
  }
`;

const Label = styled.button`
  display: inline-block;
  margin-left: ${rem(15)};
  color: ${colors.blue['800']};
  font-weight: ${fontWeights.semiBold};
  cursor: pointer;
  appearance: none;
  background: none;
  border: none;
  padding: 0;
`;

const Toggle = ({ className, label, defaultValue = false, onChange }) => {
  const [active, setActive] = useState(defaultValue);

  const handleClick = () => {
    if (onChange) {
      onChange(!active);
    }

    setActive((a) => !a);
  };

  return (
    <Container className={className}>
      <ToggleButton
        onClick={handleClick}
        type="button"
        aria-pressed={active}
        aria-label={label}
      />
      {label && (
        <Label onClick={handleClick} type="button" aria-hidden="true">
          {label}
        </Label>
      )}
    </Container>
  );
};

Toggle.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  defaultValue: PropTypes.bool
};

export default Toggle;
